<template>
  <v-tooltip v-if="statusSettings" left color="grey" :z-index="9">
    <template #activator="{ on }">
      <v-icon v-on="on" :color="statusSettings.color">{{ statusSettings.icon }}</v-icon>
    </template>
    <span>{{ statusSettings.label }}</span>
  </v-tooltip>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import moment from 'moment';

const props = defineProps({
  published: { type: Boolean, default: false },
  states: {
    type: Array,
    default: () => []
  }, // All states
  endPublicationDate: { type: Number, default: null },
  isOnline: { type: Boolean, default: false },
  status: { type: String, default: 'draft' } // Current status
});

const getColor = computed(() => {
  if (props.status === 'draft' || !props.isOnline || props.endPublicationDate) {
    if (props.endPublicationDate) {
      return moment().unix() < props.endPublicationDate ? 'green' : 'grey';
    }
    return 'black';
  }

  if (props.published && props.isOnline && !props.endPublicationDate) {
    return 'green';
  }

  return null;
});

const statusSettings = computed(() => {
  const currentState = props.states.find(state => props.status === state.id);

  if (!currentState) {
    return null;
  }

  const icon = props.published ? 'check_circle' : 'remove_circle';
  const color = getColor.value;

  return { ...currentState, color: color, icon: icon };
});

</script>

<style scoped>
.search-bar {
  margin-top: 10px;
}
</style>
